export default [
  'advertiseObjectService', 'analyticsService',
  function (advertiseObjectService, analyticsService)
  {
    this.isRequestSend = false;
    this.isRequestError = false;
    this.modalHeader = 'Отправить заявку?';

    this.advertiseObjectText = advertiseObjectService.getABGroup() === 'A'
      ? 'Информация об объекте и ваши контакты будут отправлены специалисту. Он свяжется с вами в ближайшее время, проконсультирует и ответит на любые вопросы'
      : 'Информация об объекте и ваши контакты будут отправлены специалисту. Он свяжется с вами как только появится клиент на просмотр';

    this.sendAdvertiseRequest = () => {
      advertiseObjectService.sendAdvertiseRequestFromModal().then(() => {
        analyticsService.trackAdvertiseRequestSend();
        this.isRequestSend = true;
        advertiseObjectService.isRequestSend = true;
        this.modalHeader = 'Заявка отправлена';
      }, () => {
        this.isRequestSend = true;
        this.modalHeader = 'Произошла ошибка';
        this.isRequestError = true;
      });
    };
  }
];
